import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import MenuItem from '@mui/material/MenuItem';
import INVOICE_OPERATION_STATES_OPTIONS, {
  INVOICE_STATUS_FILTER_ALL_OPTION,
  INVOICE_STATUS_FILTER_DEFAULT_LABEL,
  INVOICE_STATUS_FILTER_VALUE,
} from '../../constants/invoice-operation-states-options';
import { FORM_SELECT_BUTTON_CLASS_NAME, FORM_SELECT_MENU_CLASS_NAME } from '../../theme/constants/select';
import SelectButton from '../buttons/SelectButton';

const InvoiceStatusFilter = ({
  states,
  setStates,
  options = INVOICE_OPERATION_STATES_OPTIONS,
  label,
  ...props
}) => {
  const [selectedStatus, setSelectedStatus] = useState(INVOICE_STATUS_FILTER_VALUE.ALL);
  const { status, ...rest } = states;
  const handleChangeInvoiceStatus = (e) => {
    setSelectedStatus(e.target.value);
    setStates(
      { ...rest,
        ...options.find(
          (el) => el.value === e.target.value,
        ).filter,
      },
    );
  };

  const renderValue = (selected) => {
    const option = options.find((stateOption) => stateOption.value === selected);
    return `${label}: ${option?.label ?? INVOICE_STATUS_FILTER_ALL_OPTION.label}`;
  };

  return (
    <SelectButton
      value={selectedStatus}
      onChange={handleChangeInvoiceStatus}
      className={FORM_SELECT_BUTTON_CLASS_NAME}
      MenuProps={{ PaperProps: { className: FORM_SELECT_MENU_CLASS_NAME } }}
      renderValue={renderValue}
      SelectDisplayProps={{ style: { paddingRight: 30 } }}
      {...props}
    >
      {options.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value}
        >
          {option.label}
        </MenuItem>
      ))}
    </SelectButton>
  );
};
InvoiceStatusFilter.propTypes = {
  states: PropTypes.shape({
    dteType_CountryId: PropTypes.string,
    hasActiveOperation: PropTypes.bool,
    preoffer_Preofferevaluationrequest_RequestingPlatform_Code: PropTypes.string,
    status: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  setStates: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    filter: PropTypes.shape({
      status: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
  })),
  label: PropTypes.string,
};

InvoiceStatusFilter.defaultProps = {
  options: INVOICE_OPERATION_STATES_OPTIONS,
  label: INVOICE_STATUS_FILTER_DEFAULT_LABEL,
};

export default InvoiceStatusFilter;
